import React from 'react';
import {Button, PriorityIcon, Text} from '@priority-software/priority-style-react';
import texts from '../../../../texts';
import styles from './Container.module.scss';

type Props = {
    containerType?: string;
    isShortcuts?: boolean;
    addNewItemToGroup?: () => void;
};

export const EmptyContent = (props: Props) => {
    const {isShortcuts, addNewItemToGroup} = props;

    const renderContent = () => {
        if (isShortcuts) {
            return (
                <>
                    <Text skin={'paragraph-2'} tag="p">
                        {texts.shortcuts_empty_state}
                    </Text>
                    <Button
                        componentClasses={styles.addBtn}
                        prefixIcon={PriorityIcon.newAdd}
                        skin="secondary"
                        onClick={addNewItemToGroup}
                    >
                        {texts.add_shortcuts}
                    </Button>
                </>
            );
        }
        return (
            <>
                <Text skin={'paragraph-2'} tag="p">
                    {texts.tiles_section_empty_state}
                </Text>
                <Button
                    componentClasses={styles.addBtn}
                    prefixIcon={PriorityIcon.newAdd}
                    skin="secondary"
                    onClick={addNewItemToGroup}
                >
                    {texts.add_tile_btn}
                </Button>
            </>
        );
    };

    return <div className={styles.emptyState}>{renderContent()}</div>;
};
